import { Fragment } from "react"
import BackDropModal from "../backDropModal"
import ReactDOM from "react-dom"
import { useRequestProcessor } from "../../../api/requestProcessor"
import { getOrdersPayment } from "../../../api/orders"


const OrderpaymentComponent = ({ data, type, deleteHandler, onConfirm }) => {

    const { Query, Mutate } = useRequestProcessor()

    const { data: paymentData } = Query(
        ['getOrdersPayments', data.id],
        () => getOrdersPayment(data.id)
    );


    return (
        <div key={data.id} className="fixed top-[20%] left-[15%] z-10">
            <div className="w-[1000px] py-6 px-4 flex-col rounded-2xl bg-white h-1/2 font-bold ">
                <div className="flex justify-between items-center border-b py-2">
                    <h1 className="text-[1rem] font-bold">مشخصات پرداخت {data.user.name}</h1>
                    <div onClick={() => onConfirm()}>X</div>
                </div>
                <div className="flex-col items-center my-5">
                    <table className="table-auto transition-all" >
                        <thead className="!py-2">
                            <tr className=" border-b border-black text-sm">
                                <th className="py-3">#</th>
                                <th className="py-3">قیمت</th>
                                <th className="py-3">آیدی سازنده</th>
                                <th className="py-3">تاریخ ایجاد</th>
                                <th className="py-3">کد رهگیری</th>
                                <th className="py-3">وضعیت پرداخت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                paymentData?.data?.length ?
                                    paymentData?.data?.map(el => (
                                        <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                            <td className="text-center py-5" >{el.id}</td>
                                            <td className="text-center py-5" >
                                                <div className="bg-[#2196f3] py-2 text-white rounded-[1rem]">
                                                    {Intl.NumberFormat().format(+el.price) + " تومان"}
                                                </div>
                                            </td>
                                            <td className="text-center py-5" >
                                                {el.creator_id}
                                            </td>

                                            <td className="text-center py-5" >
                                                <p>{el.created_at?.split(" ")[0]}</p>
                                                <p>{el.created_at?.split(" ")[1]}</p>
                                            </td>
                                            
                                            <td className="text-center py-5" > {el.code}</td>
                                            <td className="text-center py-5 flex items-center justify-evenly" >
                                                {
                                                    el.payment ?
                                                        <p className="font-bold text-green-500">پرداخت شده</p>
                                                        :
                                                        <p className="font-bold text-red-500">پرداخت نشده</p>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <div>
                                        <p>هیچ سفارشی پیدا نشد</p>
                                    </div>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}


const OrderPaymentModal = ({ onConfirm, data, type }) => {
    return (
        <Fragment>
            {ReactDOM.createPortal(<BackDropModal onConfirm={onConfirm} />, document.getElementById("backdrop-root"))}
            {ReactDOM.createPortal(<OrderpaymentComponent data={data} type={type} onConfirm={onConfirm} />, document.getElementById("modal-root"))}
        </Fragment>
    )
}


export default OrderPaymentModal